import * as React from "react";
import { SVGProps } from "react";

const SwarmCity = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="Layer_1"
    viewBox="0 0 2000 2000"
    {...props}
  >
    <style>{".st1{fill:#333}"}</style>
    <path fill="#efd96f" d="M0 0h2000v2000H0z" />
    <g id="Thanks_to_Pieter_Boels_x21_">
      <path
        d="M1423 732c-228 0-416 183-586 335-49-43-104-96-146-146-4-5-10-6-13-4-4 3-5 9-1 13 39 48 91 106 140 155-91 86-230 190-342 190-226 0-227-313-29-372 9-2 9-13 0-10-259 64-245 429 34 429 133 0 255-89 378-194 133 120 301 218 517 218 548 0 532-614 48-614zm-52 567c-173-1-341-77-488-192 167-145 336-311 535-311 388 0 398 506-47 503z"
        className="st1"
      />
      <circle cx={564} cy={861} r={56} className="st1" />
    </g>
  </svg>
);

export default SwarmCity;
